<template></template>

<script>
export default {
    props: ["emails_count"],
    data() {
        return {
            count: parseInt(this.emails_count),
        };
    },
    created() {
        for (let i = 0; i < this.count; i++) {
        }
    },
};
</script>
